import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppBaseHttpService } from '../../shared/services/app-base-http.service';
import { SpinnerService } from '../../shared/services/spinner.service';
import { User } from '../models';
import { Applicant } from '../models/Applicant';
import { AppConfig } from './../../core/config/app.config';
import { AppConfigConstants } from './../../core/config/app.config.constants';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {


  constructor(private http: HttpClient,
    private spinnerService: SpinnerService,
    private baseHttpService: AppBaseHttpService) { }



  loggedInApplicant(): Observable<Applicant> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
      AppConfigConstants.LOGIN_URL_SEGMENT]).concat(`/loggedInApplicant`);
    return this.baseHttpService.post(url, null);
  }

  logoutApplicant(): Observable<Applicant> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.LOGIN_URL_SEGMENT]).concat(`/logoutApplicant`);
    return this.baseHttpService.post(url, null);
  }

  loggedInUser(): Observable<User> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.LOGIN_URL_SEGMENT]).concat(`/loggedInUser`);
    return this.baseHttpService.post(url, null);
  }

  logoutUser(): Observable<User> {
    const url = AppConfig.appSettingConcat([AppConfigConstants.API_SERVER_URL,
    AppConfigConstants.LOGIN_URL_SEGMENT]).concat(`/logoutUser`);
    return this.baseHttpService.post(url, null);
  }
}
